import { PointItem } from 'components/point-item';
import { FormatNumber } from 'utils/helpers';

import SemRegistros from '../SemRegistros';

interface AcoesEcoaProps {
  itens: any[];
  totalDoCiclo?: number;
  cicloLabel?: string;
}

export default function AcoesEcoa({ itens, totalDoCiclo, cicloLabel }: AcoesEcoaProps) {
  return (
    <div className="flex flex-col gap-3.5">
      <section
        aria-labelledby="titulo-ecoa"
        className="flex flex-wrap items-center gap-6 rounded-2xl bg-brand-purple-light px-6 py-[26px] lg:px-[30px]"
      >
        <div className="min-w-[240px] flex-1">
          <h2 id="titulo-ecoa" className="m-0 mb-1 font-display text-xl font-bold text-brand-blue-dark">
            Ações Ecoa
          </h2>
          <p className="m-0 max-w-[58ch] text-sm text-content">
            As ações do programa Ecoa que você concluiu no ciclo. Cada participação vira ponto no Joga Junto.
          </p>
        </div>
        <div className="rounded-xl bg-surface-0 px-[22px] py-3.5 text-center shadow-jj-01">
          <div className="mb-1 text-xs text-content-soft">Total no ciclo</div>
          <div className="font-display text-[26px] font-extrabold leading-none text-brand-blue">
            {FormatNumber(totalDoCiclo ?? 0, false)}
          </div>
        </div>
      </section>

      {itens.length === 0 ? (
        <SemRegistros />
      ) : (
        <div className="flex flex-col gap-3.5">
          {itens.map(item => (
            <PointItem key={item._id} data={item} cycleLabel={cicloLabel} />
          ))}
        </div>
      )}
    </div>
  );
}
